module.exports = __webpack_public_path__ + "assets/02719df7470e198785c68e87040e7dc8.svg";